import { DropdownButton, StandardButton } from "../atoms/buttons"
import Checkbox from "../atoms/checkboxnew"
import { HorizontalLayout } from "./layout"

export const UserRights = ({rights,changeSelected}) => {
    return(
        <HorizontalLayout style={{marginTop:"0.5rem"}}>
            <Checkbox onChange={changeSelected} checked={rights?.selected}/>
            <p className="normal-text-dark text-margin-left light-bold">{rights.description}</p>
        </HorizontalLayout>
    )
}


export const UserRoles = ({roles,activeRole,activateRole,openModal}) => {
    return (
        <HorizontalLayout className="standard-small-margin-top">
            <DropdownButton marginLeft="unset" optionSelected={(value) => activateRole(value)} content={activeRole} dropdown={roles} />
            <StandardButton onClick={openModal} title={"+ Gebruikersrol"}/>
        </HorizontalLayout>
    )
}